import { render } from "./I18nPhoneNumberInput.vue?vue&type=template&id=8fe4070e"
import script from "./I18nPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./I18nPhoneNumberInput.vue?vue&type=script&lang=js"

import "./I18nPhoneNumberInput.vue?vue&type=style&index=0&id=8fe4070e&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__